import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Row,
  Select,
  Button,
  DatePicker,
  Form,
  InputNumber,
  Popconfirm,
  Tooltip,
  Table,
  Switch,
  Card,
} from "antd";
import { useTranslation } from "react-i18next";
import { noWhitespace } from "../../../utils/rules";
import { notify } from "../../../redux/actions";
import aictia from "../../../const/api";
import moment from "moment";
import { connect } from "react-redux";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { convertColumns } from "../../../utils/columnconverter";
import {
  EditFilled,
  DeleteFilled,
} from "@ant-design/icons";
// import ProjectTablee from "../project/table"
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from "primereact/floatlabel";
const { Option } = Select;

function Innovation(props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const mainUrl = "Innovation";
  const role = localStorage.getItem("role");
  const [fieldOfUse, setFieldOfUse] = useState([]);
  const [typeOfInnovation, setTypeOfInnovation] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoriesType, setCategoriesType] = useState([]);
  const [cutValue, setCutValue] = useState();
  const [subDisable, setSubDisable] = useState(true);
  const [typeDisable, setTypeDisable] = useState(true);
  const [positions, setPositions] = useState([]);
  const [spin, setSpin] = useState(false);
  const [editing, setEditing] = useState(null);
  const [field, setField] = useState([]);
  const [innovationCate, setInnovationCate] = useState([]);
  const [techArray, setTechArray] = useState([0]);

  const [isInnovationCer, setIsInnovationCer] = useState(false);
  const [isPatent, setIsPatent] = useState(false);

  // props
  const { notify } = props;

  const getFieldOfUse = () => {
    aictia.get("UsageArea").then((res) => {
      setFieldOfUse(res.data);
    });
  };
  //
  const getTypeOfProject = () => {
    aictia.get("TypeOfInnovation").then((res) => {
      setTypeOfInnovation(res?.data);
    });
  };
  //cate
  const getCategories = () => {
    aictia.get("TechnologyFilter/TechnologyFields").then((res) => {
      setCategories(res.data.technologyCagegory);
    });
  };

  //subcate
  const getSubcategories = (value, index) => {
    let cate = subCategories;

    cate = cate.filter((elem) => elem.index !== index);

    const subCate = categories.find(
      (item) => item.id === value
    ).technologySubCagegory;
    setSubCategories([...cate, { index: index, array: subCate }]);

    setSubDisable(false);
    form.resetFields([
      ["innovationCategories", index, "technologySubcategoryId"],
    ]);
    form.resetFields([["innovationCategories", index, "technologyTypeId"]]);
  };

  //type
  const getCategoriesType = (value, index) => {
    let cateType = categoriesType;
    cateType = cateType.filter((item) => item.index !== index);
    const data = subCategories.find((item) => item.index === index).array;
    const type = data.find((item) => item.id === value).technologyType;

    setCategoriesType([...cateType, { index: index, array: type }]);

    setTypeDisable(false);
    form.resetFields([["innovationCategories", index, "technologyTypeId"]]);
  };

  const setEditingObject = async (i) => {
    setEditing(i);

    await aictia.get(mainUrl + `/${i}`).then((res) => {
      setSubDisable(false);
      setTypeDisable(false);
      setField(res.data.innovationUsageAreas);
      setInnovationCate(res?.data.innovationCategories);
      const techArray1 = [];
      let subCategoriesModify = [];
      let categoriesTypeModify = [];
      if (res.data.innovationCategories.length !== 0) {
        res.data.innovationCategories.map((item, index) => {
          techArray1.push(index);

          //subCate
          const subCate = categories.find(
            (elem) => elem.id === item.technologyCategoryId
          ).technologySubCagegory;
          subCategoriesModify = [
            ...subCategoriesModify,
            { index: index, array: subCate },
          ];

          //type
          const data = subCategoriesModify.find(
            (elem) => elem.index === index
          ).array;
          const type = data.find(
            (elem) => elem.id === item.technologySubcategoryId
          ).technologyType;
          categoriesTypeModify = [
            ...categoriesTypeModify,
            { index: index, array: type },
          ];
        });
      } else {
        techArray1.push(0);
        subCategoriesModify = [
          ...subCategoriesModify,
          { index: 0, array: [] },
        ];
        categoriesTypeModify = [
          ...categoriesTypeModify,
          { index: 0, array: [] },
        ];
      }
      setSubCategories(subCategoriesModify);
      setCategoriesType(categoriesTypeModify);
      setTechArray(techArray1);

      setTimeout(() => {
        form.setFieldsValue({
          ...res.data,
          startDate: res.data.startDate ? moment(res.data.startDate) : null,
          endDate: res.data.endDate ? moment(res.data.endDate) : null,

          usageAreaId: res.data.innovationUsageAreas.map(
            (item) => item.usageAreaId
          ),
        });
        setIsInnovationCer(res.data.certificate);
        setIsPatent(res.data.patent);
      }, 1000);
    });
  };

  const getPositions = async () => {
    setSpin(true);
    await aictia.get(`${mainUrl}?companyid=${props.id}`).then((res) => {
      setSpin(false);
      setPositions(
        res.data.map((p, index) => {
          return {
            key: index + 1,
            ...p,
            index: index + 1,
          };
        })
      );
    });
  };

  const deletePosition = async (i) => {
    await aictia
      .delete(`${mainUrl}/${i}`)
      .then(() => {
        // description
        notify("silindi", true);
        getPositions();
      })
      .catch((err) => {
        //error
        notify(err.response, false);
      });
  };

  const cancelEditing = () => {
    setEditing(null);
    setTechArray([0]);
    setIsInnovationCer(false);
    setIsPatent(false);
    form.resetFields();
  };
  const save = async (values) => {
    const data = {
      ...values,
      reyestrOfCompanyId: props.id,
      certificate: isInnovationCer,
      patent: isPatent,
      // innovationCategories: values?.innovationCategories[0].technologyCategoryId ? values?.innovationCategories : [],
      innovationCategories: values.innovationCategories.filter(
        (innovation) => innovation?.technologyCategoryId),
      innovationUsageAreas: values?.usageAreaId ? values?.usageAreaId.map((item) => {
        return {
          usageAreaId: item,
        };
      }) : [],
    };

    if (!editing) {
      await aictia
        .post(mainUrl, data)
        .then((res) => {
          notify("", true);
          getPositions();
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    } else {
      //field
      const dataUsageAreaIds = data.innovationUsageAreas.map(
        (item) => item.usageAreaId
      );
      const updateFieldsIds = field.map((elem) => elem.usageAreaId);
      const updatedField = field.map((item) => {
        const isActive = dataUsageAreaIds.includes(item.usageAreaId);
        return { ...item, isActive };
      });

      data.innovationUsageAreas.map((elem) => {
        elem.isActive = true;
      });
      data.innovationUsageAreas = data?.innovationUsageAreas.filter(
        (elem) => !updateFieldsIds.includes(elem.usageAreaId)
      );
      data.innovationUsageAreas.push(...updatedField);

      //cate
      const modifyData = data?.innovationCategories.filter(item => item !== undefined)
      const innovationCategoryIds = modifyData.map(
        (item) => item.id
      );

      const updatedInnovationCate = innovationCate.map((item) => {
        const isActive = innovationCategoryIds.includes(item.id);
        return { ...item, isActive };
      });

      const filteredModifyData = modifyData.filter((elem) => {
        if (elem.technologyCategoryId === undefined) {
          return false;
        }
        elem.isActive = true;
        return true;
      });
      filteredModifyData.push(
        ...updatedInnovationCate.filter((elem) => elem.isActive === false && elem.technologyCategoryId)
      );

      data.innovationCategories = filteredModifyData
      await aictia
        .put(`${mainUrl}/${editing}`, { ...data, id: editing })
        .then((res) => {
          notify("", true);
          getPositions();
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    }
  };

  useEffect(() => {
    getFieldOfUse();
    getTypeOfProject();
    getCategories();
    getPositions();
  }, []);

  const cols = [
    { key: "index", value: "#", con: true },
    { key: "innovationName", value: "İnnovasiyanın adı", con: true },
    { key: "inventor", value: "İcad edən şəxs", con: true },
    { key: "typeOfInnovation", value: "İnnovasiyanın növü", con: true },
    { key: "id", value: "", con: false },
  ];
  const columns = [
    {
      title: "#",
      key: "1",
      dataIndex: "index",
      width: 80,
    },
    {
      title: "İnnovasiyanın adı",
      key: "2",
      dataIndex: "innovationName",
    },
    {
      title: "İcad edən şəxs",
      key: "3",
      dataIndex: "inventor",
    },
    {
      title: "Başlama tarixi ",
      dataIndex: "startDate",
      key: "4",
      render: (i) => {
        return i ? moment(i).format("YYYY-MM-DD") : " ";
      },
    },
    {
      title: "Bazara giriş  tarixi ",
      dataIndex: "endDate",
      key: "5",
      render: (i) => {
        return i ? moment(i).format("YYYY-MM-DD") : " ";
      },
    },
    {
      title: "İnnovasiyanın növü",
      dataIndex: "typeOfInnovation",
      key: "6",
      render: (i) => {
        return <p>{i.name}</p>;
      },
    },
    {
      title: "Büdcə",
      dataIndex: "budget",
      key: "7",
      render: (i) => {
        return <p>{i} azn</p>;
      },
    },
    {
      title: "",
      key: "8",
      dataIndex: "id",
      width: 30,
      render: (i) => {
        return (
          <div className="flex flex-end">
            {role === "Admin" && (

              <Popconfirm
                placement="topRight"
                title={t("areYouSure")}
                onConfirm={() => deletePosition(i)}
                okText={t("yes")}
                cancelText={t("no")}
              >
                <Tooltip className="ml-5" title={t("delete")}>
                  <Button className="border-none" type="text" shape="circle">
                    <DeleteFilled />
                  </Button>
                </Tooltip>
              </Popconfirm>
            )}
            <Tooltip className="ml-5" title={t("edit")} placement="topRight">
              <Button
                className="border-none"
                type="text"
                shape="circle"
                onClick={() => setEditingObject(i)}
              >
                <EditFilled />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];
  const handleDeleteRow = (element) => {
    if (techArray.length > 1) {
      setTechArray(techArray.filter((elem) => elem !== element));
      form.resetFields([
        ["innovationCategories", element, "technologyCategoryId"],
      ]);
      form.resetFields([
        [["innovationCategories", element, "technologySubcategoryId"]],
      ]);
      form.resetFields([
        [["innovationCategories", element, "technologyTypeId"]],
      ]);
    }
  };

  return (
    <div>

      <Form layout="vertical" onFinish={save} form={form}>
        <div className={`commontask taskkk detail mb-30`}>
          <Card>
            <Row gutter={[16, 32]}>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="innovationName"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="innovationName" />
                  </Form.Item>
                  <label htmlFor="innovationName">{t("İnnovasiyanın adı ")} <span style={{ color: 'red' }}> *</span></label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="inventor"
                    validateTrigger="onChange"
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="inventor" />
                  </Form.Item>
                  <label htmlFor="inventor">{t("İcad edən şəxs ")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="startDate"
                    validateTrigger="onChange"
                  >
                    <DatePicker style={{borderRadius: "12px"}} placeholder={t("Tarixi seçin")} className="w-100" />
                  </Form.Item>
                  <label htmlFor="startDate">{t("Başlama tarixi")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="endDate"
                    validateTrigger="onChange"
                  >
                    <DatePicker style={{borderRadius: "12px"}} placeholder={t("Tarixi seçin")} className="w-100" />
                  </Form.Item>
                  <label htmlFor="endDate">{t("Bazara giriş tarixi")}</label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="usageAreaId"
                    validateTrigger="onChange"
                  //   rules={[whiteSpace(t("inputError"))]}
                  >
                    <Select
                    className="custom-select"
                      id="usageAreaId"
                      mode="multiple"
                      maxTagCount={1}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      maxTagPlaceholder={(omittedValues) => (
                        <span>+{omittedValues.length}</span>
                      )}
                    >
                      {fieldOfUse.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>

                  </Form.Item>
                  <label htmlFor="usageAreaId">{t("İstifadə sahəsi")}</label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="typeOfInnovationId"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}

                  >
                    <Select className="custom-select">
                      {typeOfInnovation.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <label htmlFor="typeOfInnovationId">{t("İnnovasiyanın növü")}<span style={{ color: 'red' }}> *</span></label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <div className="form-lang">

                    <Form.Item
                      name="budget"
                      validateTrigger="onChange"
                    >
                      <InputNumber style={{borderRadius: "12px"}} id="budget" defaultValue={0} className="w-full" size={"large"} />
                    </Form.Item>
                    <div className="input-lang">azn</div>
                  </div>
                  <label htmlFor="budget">{t("Büdcə")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>

                  <Form.Item
                    name="webPageUrl"
                    validateTrigger="onChange"
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="webPageUrl" />
                  </Form.Item>
                  <label htmlFor="webPageUrl">{t("Web səhifə")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <div className="flex mb-15" >
                  <Switch
                    className={"mr-15"}
                    checked={isInnovationCer}
                    onChange={() => {
                      setIsInnovationCer(!isInnovationCer);
                    }}
                  />
                  <span className="mr-15"> İnnovasiya sertifikatı</span>
                  <span className={isInnovationCer ? "green" : "red"}>
                    {isInnovationCer ? "+" : "-"}
                  </span>
                </div>
                <div className="flex mb-15">
                  <Switch
                    className={"mr-15"}
                    checked={isPatent}
                    onChange={() => {
                      setIsPatent(!isPatent);
                    }}
                  />
                  <span className="mr-15">Patent </span>
                  <span className={isPatent ? "green" : "red"}>
                    {isPatent ? "+" : "-"}
                  </span>
                </div>
              </Col>

              {techArray.map((elem, index) => (
                <Col className="flex  flex-align-center " key={index} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <div style={{ display: "none" }}>
                    <FloatLabel>
                      <Form.Item
                        name={["innovationCategories", elem, "id"]}
                        validateTrigger="onChange"
                      >
                        <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="id" />
                      </Form.Item>
                      <label htmlFor="id">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </div>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>

                      <Form.Item
                        name={[
                          "innovationCategories",
                          elem,
                          "technologyCategoryId",
                        ]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select" onChange={(value) => getSubcategories(value, elem)}>
                          {categories.map((p, index) => {
                            return (
                              <Option key={index} value={p.id}>
                                {p.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyCategoryId">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </Col>

                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={[
                          "innovationCategories",
                          elem,
                          "technologySubcategoryId",
                        ]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select"
                          onChange={(value) => getCategoriesType(value, elem)}
                          disabled={subDisable}
                        >
                          {subCategories?.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologySubcategoryId">{t("Alt kateqoriyası")}</label>
                    </FloatLabel>

                  </Col>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={["innovationCategories", elem, "technologyTypeId"]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select" disabled={typeDisable}>
                          {categoriesType.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyTypeId">{t("Növü")}</label>
                    </FloatLabel>
                  </Col>

                  <div>
                    <Button
                      onClick={() => setTechArray([...techArray, techArray[techArray.length - 1] + 1])}
                      className={"ml-15"}
                      type={"primary"}
                      shape={"circle"}
                      icon={<PlusOutlined />}
                    />
                    <Button
                      onClick={() => {
                        handleDeleteRow(elem);
                      }}
                      className={"ml-15"}
                      type={"primary"}
                      shape={"circle"}
                      icon={<MinusOutlined />}
                    />
                  </div>
                </Col>
              ))}
            </Row>
            <div className="flex flex-end mb-20">
              <Button style={{borderRadius: "12px"}} onClick={cancelEditing}>{t("cancel")}</Button>

              <Button style={{borderRadius: "12px"}} type="primary" className="ml-10" htmlType="submit">
                {t("save")}
              </Button>
            </div>
          </Card>
        </div>
      </Form>
      <div className="commontask taskkk detail">
        <Card>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Table
                loading={spin}
                size="small"
                className="bg-whit animated fadeInLeft mt-15"
                columns={columns}
                dataSource={convertColumns(positions, cols)}
                pagination={{
                  pageSize: 10,
                  current_page: 1,
                  total: positions.length,
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
}

export default connect(null, { notify })(Innovation);

